import { useLocalization } from "@fluent/react";
import { Radio } from "@narmi/design_system";
import styles from "../Select.module.css";
import { MembershipLabel } from "./MembershipLabel";
import type { components } from "../../../../../types/schema-lending";

type Membership = components["schemas"]["Membership"];

interface MembershipOptionsListProps {
  memberships: Membership[];
  selectedMembershipCoreUserId: string | null;
  onSelectMembership: (value: string) => void;
}

function MembershipOptionsList({
  memberships,
  selectedMembershipCoreUserId,
  onSelectMembership,
}: MembershipOptionsListProps) {
  const { l10n } = useLocalization();

  return (
    <div
      className={styles.membershipDetailsList}
      role="radiogroup"
      aria-label={l10n.getString(
        "membership-share-select-membership-options-label",
        null,
        "Membership options"
      )}
    >
      {memberships.map((membership) => (
        <div
          key={membership.core_user_id ?? membership.display_name}
          className={styles.membershipOptionRow}
        >
          <Radio
            name="selected-membership"
            value={membership.core_user_id ?? ""}
            checked={membership.core_user_id === selectedMembershipCoreUserId}
            onCheck={onSelectMembership}
          >
            <MembershipLabel displayName={membership.display_name} />
          </Radio>
        </div>
      ))}
    </div>
  );
}

export { MembershipOptionsList };
